// src/components/CurrentPositionsMap.js (or your path)
import React from 'react';
import { useSelector } from 'react-redux';
import PositionsMapGoogle from './PositionsMapGoogle'; // Ensure this path is correct

// This component now needs to accept the props passed by <Map>
const CurrentPositionsMapGoogle = ({ map, googleMapsApi, icons }) => {
    const positions = useSelector(state => Object.values(state.positions.items));
    // Pass the received props along with the new 'positions' prop
    return (
        <PositionsMapGoogle
            map={map}
            googleMapsApi={googleMapsApi}
            icons={icons}
            positions={positions}
        />
    );
};

export default CurrentPositionsMapGoogle;